const list = {
  path: 'list',
  component: resolve => require(['@/pages/admin/merchant/signing/yftWeChat/accessPay/list/index'], resolve)
}

export default list
